var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasGeometry
    ? _c(_vm.tag, { tag: "component", class: _vm.className }, [
        _c("i", {
          staticClass: "fas fa-map-marked-alt action view-on-map",
          attrs: {
            "data-toggle": "tooltip-city",
            "data-placement": "left",
            title: _vm.$t(`${_vm.title}`),
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onViewGeometry.apply(null, arguments)
            },
          },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }